module.exports = __webpack_public_path__ + "img/1552821786.6951a2b1.jpg";